import React, { useEffect, useRef } from 'react';
import Create from './Create';
import { DraftListing } from '../../contexts/DraftListingContext';
import { ErrorBoundary } from '../../components/common/ErrorBoundary';
import FallbackError from '../../components/common/FallbackError';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { useModal } from '../../contexts/ModalContext';
import { FeatureFlags } from '../../flags';
import { KEYSTONE_REDIRECT_URL } from '../../config';
import { navigateTo } from '../../utils';
import ResponsiveLayout, {
  AnchorPosition,
} from '../../components/common/ResponsiveLayout';

const CreateWrapper: React.FC = () => {
  const { getFeatureValue, hasFeature, setTrait } = useFeatureFlags();
  const { showModal } = useModal();
  const modalShownRef = useRef(false);

  useEffect(() => {
    if (
      !modalShownRef.current &&
      hasFeature(FeatureFlags.NGW_SHOW_INIT_MODAL)
    ) {
      const modalConfig = getFeatureValue(FeatureFlags.NGW_SHOW_INIT_MODAL);
      if (modalConfig) {
        showModal({
          title: modalConfig.title,
          content: (
            <div
              dangerouslySetInnerHTML={{
                __html: modalConfig.content.replace(
                  '{LEGACY_LINK}',
                  KEYSTONE_REDIRECT_URL,
                ),
              }}
            />
          ),
          width: modalConfig.width ?? 'sm', // small modal size by default
          confirmText: modalConfig.continueText,
          cancelText: modalConfig.returnText,
          switchLayout: false,
          onCancel: async () => {
            await setTrait(FeatureFlags.NGW_ENROLLMENT, false);
            navigateTo(`${KEYSTONE_REDIRECT_URL}#New`);
          },
          modalStyles: {
            '.MuiPaper-root': {
              p: 3,
            },
            '.MuiDialogTitle-root': {
              fontSize: '20px',
              pt: 0,
              px: 0,
            },
            '.MuiDialogContent-root': {
              p: 0,
            },
            '.MuiDialogActions-root': {
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: { sm: 'space-evenly ' },
              '.MuiButton-root': {
                width: { xs: 1, sm: 'auto' },
              },
            },
          },
        });
        modalShownRef.current = true;
      }
    }
  }, [hasFeature, getFeatureValue, showModal, setTrait]);

  return (
    <DraftListing>
      <ErrorBoundary fallback={<FallbackError />}>
        <ResponsiveLayout width={'100%'} anchor={AnchorPosition.TOP_LEFT}>
          <Create />
        </ResponsiveLayout>
      </ErrorBoundary>
    </DraftListing>
  );
};

export default CreateWrapper;
